import React from "react";

import { Icon, WrappingIconProps } from "../Icon";

export const GAuthIcon = (props: WrappingIconProps) => {
  return (
    <Icon {...props}>
      <g id="surface1">
        <path
          fill="var(--theme-neutral-1000)"
          d="M 24 12 C 24 18.628906 18.628906 24 12 24 C 5.371094 24 0 18.628906 0 12 C 0 5.371094 5.371094 0 12 0 C 18.628906 0 24 5.371094 24 12 Z M 24 12 "
        />
        <path
          fill="rgb(100%,54.901961%,0%)"
          d="M 5.894531 10.949219 C 5.894531 10.480469 6.273438 10.105469 6.738281 10.105469 L 17.261719 10.105469 C 17.726562 10.105469 18.105469 10.480469 18.105469 10.949219 L 18.105469 17.683594 C 18.105469 18.148438 17.726562 18.527344 17.261719 18.527344 L 6.738281 18.527344 C 6.273438 18.527344 5.894531 18.148438 5.894531 17.683594 Z M 5.894531 10.949219 "
        />
        <path
          fill="rgb(100%,54.901961%,0%)"
          d="M 14.316406 12 L 14.316406 9.894531 C 14.316406 8.617188 13.277344 7.578125 12 7.578125 C 10.722656 7.578125 9.683594 8.617188 9.683594 9.894531 L 9.683594 12 C 9.683594 13.277344 10.722656 14.316406 12 14.316406 C 13.277344 14.316406 14.316406 13.277344 14.316406 12 Z M 12 5.472656 C 9.558594 5.472656 7.578125 7.453125 7.578125 9.894531 L 7.578125 12 C 7.578125 14.441406 9.558594 16.421875 12 16.421875 C 14.441406 16.421875 16.421875 14.441406 16.421875 12 L 16.421875 9.894531 C 16.421875 7.453125 14.441406 5.472656 12 5.472656 Z M 12 5.472656 "
        />
        <path
          fill="var(--theme-neutral-1000)"
          d="M 11.367188 13.261719 C 11.367188 14.078125 10.707031 14.738281 9.894531 14.738281 C 9.082031 14.738281 8.421875 14.078125 8.421875 13.261719 C 8.421875 12.449219 9.082031 11.789062 9.894531 11.789062 C 10.707031 11.789062 11.367188 12.449219 11.367188 13.261719 Z M 11.367188 13.261719 "
        />
        <path
          fill="var(--theme-neutral-1000)"
          d="M 15.578125 13.261719 C 15.578125 14.078125 14.917969 14.738281 14.105469 14.738281 C 13.292969 14.738281 12.632812 14.078125 12.632812 13.261719 C 12.632812 12.449219 13.292969 11.789062 14.105469 11.789062 C 14.917969 11.789062 15.578125 12.449219 15.578125 13.261719 Z M 15.578125 13.261719 "
        />
        <path
          fill="var(--theme-neutral-1000)"
          d="M 9.261719 13.894531 L 10.527344 13.894531 L 10.527344 16.84375 L 9.261719 16.84375 Z M 9.261719 13.894531 "
        />
        <path
          fill="var(--theme-neutral-1000)"
          d="M 13.472656 13.894531 L 14.738281 13.894531 L 14.738281 16.84375 L 13.472656 16.84375 Z M 13.472656 13.894531 "
        />
      </g>
    </Icon>
  );
};
